"use client";

import React, { useEffect, useState } from "react";
import { Heart } from "lucide-react";
import useIsMobile from "@/components/useIsMobile";
import useMovementDetection from "@/components/useMouseMovement";
import dynamic from "next/dynamic";
const FavoriteButton = dynamic(() => import("@/components/controls/favorite-button"), {
    ssr: false,
    loading: () => <FavoriteButtonSkeleton />,
});

interface Props {
    productHandle: string;
    className?: string;
    favClassName?: string;
    unFavClassName?: string;
    favIconColor?: string;
    refresh?: boolean;
    hearthsize?: number;
    hideFlag?: boolean;
}

const FavoriteButtonLazyLoad = ({
    productHandle,
    className,
    favClassName,
    unFavClassName,
    favIconColor,
    refresh,
    hearthsize = 20,
    hideFlag = true,
}: Props) => {
    const [showLayout, setShowLayout] = useState(false);
    const hasInteracted = useMovementDetection();
    useEffect(() => {
        if (hasInteracted && !showLayout) {
            setShowLayout(true);
        }
    }, [hasInteracted, showLayout]);

    return showLayout ? (
        <FavoriteButton
            productHandle={productHandle}
            favClassName={favClassName}
            unFavClassName={unFavClassName}
            favIconColor={favIconColor}
            refresh={refresh}
            className={className}
            hearthsize={hearthsize}
            hideFlag={hideFlag}
        />
    ) : (
        <FavoriteButtonSkeleton />
    );
};

const FavoriteButtonSkeleton = () => {
    const [hearthsize, setHearthsize] = useState(20);

    const isMobile = useIsMobile();
    useEffect(() => {
        if (isMobile) {
            setHearthsize(15);
        }
    }, [isMobile]);

    return (
        <button className="inline-flex items-center justify-center whitespace-nowrap ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 text-[16px] font-normal rounded-full hover:text-c2 w-7 h-7 absolute top-2 right-2 bg-white text-c4 p-1.5">
            <Heart className={""} size={hearthsize} />
        </button>
    );
};

export default FavoriteButtonLazyLoad;
